import axios from "axios";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
import gif from "./../../assets/img/spin.gif";
import { ProgressBar } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MdArrowDropDown } from "react-icons/md";
import React, { useEffect, useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { validateHeader, API_Link } from "./../../commons/Constants";

const ScreeningDuplicate = () => {
  const formatOvidTags = (text) => {
    if (!text) return "";

    return text
      .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<b>$1</b>")
      .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
      .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
      .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
      .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
      .replace(/<ovid:br\/>/g, "<br>")
      .replace(
        /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
        "<a href='$1'>$2</a>"
      )
      .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
      .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
      .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>");
  };
  const { enqueueSnackbar } = useSnackbar();
  const MD5hash = validateHeader();
  function updateArray(arr, num) {
    // Check if the number exists in the array
    const index = arr.indexOf(num);
    if (index > -1) {
      // If the number exists, remove it from the array
      arr.splice(index, 1);
    } else {
      // If the number doesn't exist, add it to the array
      arr.push(num);
    }

    return arr;
  }
  const location = useLocation();
  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }

    return str
      .split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }

  const navigate = useNavigate();
  const [studyActive, setStudyActive] = useState(null);
  const [duplicateActive, setDuplicateActive] = useState(null);
  const [isChecked, setIsChecked] = useState(null);
  const [excludedArticlesId, setExcludedArticlesId] = useState([]);
  const [getScreeningDuplicate, setGetScreeningDuplicate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExluding, setIsExluding] = useState(false);
  const [isError, setIsError] = useState(false);
  const [options, setOptions] = useState([100, 90, 80, 70, 60, 50]);
  const [progress, setProgress] = useState(0);
  const [exactMatchedArticles, setExactMatchedArticles] = useState([]);

  // const options = Array.from({ length: 6 }, (_, index) => 100 - index * 10);
  const [selectedPercentage, setSelectedPercentage] = useState(80);
  useEffect(() => {
    localStorage.removeItem("excludedArticles");
  }, [location.pathname]);

  const handlePercentageChange = (event) => {
    const selectedValue = Number(event.target.value);
    setSelectedPercentage(selectedValue);

    const matchingArticles = getScreeningDuplicate.flatMap((article) =>
      article.duplicates
        .filter(
          (duplicate) =>
            (duplicate.percentage * 100).toFixed(2) >= selectedValue
        )
        ?.map((duplicate) => ({
          articleId: duplicate.duplicate_with,
          percentage: (duplicate.percentage * 100).toFixed(2),
        }))
    );
    setExcludedArticlesId(matchingArticles?.map((item) => item.articleId));
    getScreeningDuplicate.forEach((article) => {
      article.duplicates.forEach((duplicate) => {
        const element = document.getElementById(duplicate.duplicate_with);
        if (element) {
          if (
            matchingArticles.includes(duplicate.duplicate_with) &&
            (duplicate.percentage * 100).toFixed(2) >= selectedValue
          ) {
            element.style.backgroundColor = "rgba(255,0,0,0.2)";
          }
        }
      });
    });

    if (matchingArticles.length === 0) {
      // Clear all highlights if no matching articles
      getScreeningDuplicate.forEach((article) => {
        article.duplicates.forEach((duplicate) => {
          const element = document.getElementById(duplicate.duplicate_with);
          if (element) {
            element.style.backgroundColor = "transparent";
          }
        });
      });
    }
  };

  const handleDuplicateActive = (index, id) => {
    setStudyActive(!studyActive);
    setDuplicateActive(!duplicateActive);
    if (isChecked === true && duplicateActive === index) {
      setDuplicateActive(null);
    }
    setIsChecked(index);
    setDuplicateActive(index);
    const withoutDuplicates = [...new Set(excludedArticlesId)];
    const updatedArray = updateArray(withoutDuplicates, index);
    setExcludedArticlesId(updatedArray);
  };

  // code for capitalize
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  function shouldBeUppercase(word, index, length) {
    //always capitalize the first and last words
    if (index == 0 || index == length - 1) return true;

    //only capitalize other words if they don't match the small words pattern
    return !smallWords.test(word.toLowerCase());
  }

  function convertFirstLetterToUpperCase(str) {
    const words = str?.split(" ");

    return words
      ?.map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word?.charAt(0).toUpperCase() + word.slice(1)
          : word?.toLowerCase()
      )
      .join(" ");
  }

  const user = JSON.parse(localStorage.getItem("user"));
  const studyLocalId = JSON.parse(localStorage.getItem("studyId"));
  const token = user?.token;

  const excludeExactMatchArticles = async (uniqueExactMatchArticlesIds) => {
    const config = {
      method: "post",
      url: `${API_Link}excludeDuplicates`,
      params: {
        review_id: studyLocalId,
        stage: "1",
        exclusion_purpose: "1",
        articles: uniqueExactMatchArticlesIds,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "misr-auth": MD5hash,
      },
    };

    try {
      const { status } = await axios(config);
      if (status === 200) {
        enqueueSnackbar(
          `${uniqueExactMatchArticlesIds.length} article(s) found with a match percentage of 95% or higher and removed successfully.`,
          {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          }
        );
      }
    } catch (error) {
      console.error("Error excluding articles:", error); // Log error for debugging
      enqueueSnackbar(
        `${uniqueExactMatchArticlesIds.length} article(s) found with a match percentage of 95% or higher, but an error occurred while removing them. Please try again by clicking the Exclude button.`,
        {
          variant: "error",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
    }
  };

  const excludeArticles = () => {
    setIsExluding(true);
    let storedExcludedArticles =
      JSON.parse(localStorage.getItem("excludedArticles")) || [];

    const allExcludedArticles = [
      ...new Set([
        ...storedExcludedArticles,
        ...excludedArticlesId,
        ...exactMatchedArticles,
      ]),
    ];

    localStorage.setItem(
      "excludedArticles",
      JSON.stringify(allExcludedArticles)
    );

    var config = {
      method: "post",
      url: `${API_Link}excludeDuplicates`,
      params: {
        review_id: studyLocalId,
        stage: "1",
        exclusion_purpose: "1",
        articles: allExcludedArticles,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        if (resData.status === 200) {
          const updatedArticles = getScreeningDuplicate
            ?.map((article) => ({
              ...article,
              duplicates: article.duplicates.filter(
                (duplicate) =>
                  !allExcludedArticles.includes(duplicate.duplicate_with)
              ),
            }))
            .filter((article) => article.duplicates.length > 0);

          setGetScreeningDuplicate(updatedArticles);

          const allPercentages = updatedArticles.flatMap((article) =>
            article.duplicates?.map((duplicate) =>
              (duplicate.percentage * 100).toFixed(2)
            )
          );

          const uniquePercentages = [...new Set(allPercentages)].sort(
            (a, b) => b - a
          );

          const filteredOptions = [100, 90, 80, 70, 60, 50].filter((option) =>
            uniquePercentages.some((percentage) => percentage >= option)
          );

          setOptions(filteredOptions);

          const newSelectedPercentage = filteredOptions[0] || null;
          setSelectedPercentage(newSelectedPercentage);

          const matchingArticles = updatedArticles.flatMap((article) =>
            article.duplicates
              .filter(
                (duplicate) =>
                  Math.round(duplicate.percentage * 100) >=
                  newSelectedPercentage
              )
              ?.map((duplicate) => duplicate.duplicate_with)
          );
          setExcludedArticlesId(matchingArticles);
        }
        setIsExluding(false);
      })
      .catch(function (error) {
        alert(error);
        setIsExluding(false);
      });
  };

  function filterDuplicates(data) {
    // Step 1: If a duplicate with percentage is 100 and later becomes original, remove that record.

    // Get an array of duplicates having percentage = 100
    const duplicatesSet = new Set(
      data?.flatMap((item) =>
        item.duplicates
          // .filter((dup) => (dup.percentage * 100).toFixed(2) == 100)
          .filter((dup) => (dup.percentage * 100).toFixed(2) >= 95)
          ?.map((dup) => dup.duplicate_with)
      )
    );

    // Check if the duplicate is present in original, remove that record
    let filteredData = data.filter((item) => {
      const isOriginalAndPercentageOne = duplicatesSet.has(item.id);
      return !isOriginalAndPercentageOne;
    });

    // Step 2: Remove records where all duplicates have a percentage of 100%

    filteredData = filteredData.filter((item) => {
      // Check if all duplicates have percentage 100%
      const allDuplicatesHavePercentage100 =
        item.duplicates.length > 0 &&
        item.duplicates.every(
          // (dup) => (dup.percentage * 100).toFixed(2) == 100
          (dup) => (dup.percentage * 100).toFixed(2) >= 95
        );

      return !allDuplicatesHavePercentage100; // Remove if all have percentage 100%
    });
    // Step 3: Remove duplicates with percentage 100% in records with multiple duplicates
    filteredData = filteredData?.map((item) => {
      if (item.duplicates.length > 1) {
        // Filter out duplicates where percentage is 100%
        item.duplicates = item.duplicates.filter((dup) => {
          // return (dup.percentage * 100).toFixed(2) != 100;
          return (dup.percentage * 100).toFixed(2) < 95;
        });
      }
      return item;
    });

    return filteredData;
  }
  const fetchReviewArticles = async () => {
    let page = 1;
    let totalPages = 1; // Initialize with a value to start the loop
    const perPage = 100; // Define items per page

    try {
      let allResults = []; // Initialize results array
      let uniqueExactMatchArticlesIds = [];
      setIsLoading(true);

      do {
        const config = {
          method: "get",
          url: `${API_Link}getReviewArticles`,
          params: {
            duplicates: "Yes",
            review_id: studyLocalId || 1,
            page: page,
            per_page: perPage,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "misr-auth": MD5hash,
          },
        };

        const response = await axios(config);
        const resData = response?.data?.articles;

        // Append new results to existing results
        allResults = [...allResults, ...resData?.data];

        // Update state with the current set of results

        totalPages = resData?.last_page; // Update totalPages
        page++;
        const progressPercent = Math.min((page / totalPages) * 100, 100);
        setProgress(progressPercent);

        // allResults = removeExclude(allResults, response?.data?.excluded);

        const exactMatchingArticles = allResults.flatMap((article) =>
          article.duplicates
            .filter(
              // (duplicate) => (duplicate.percentage * 100).toFixed(2) == 100
              (duplicate) => (duplicate.percentage * 100).toFixed(2) >= 95
            )
            ?.map((duplicate) => duplicate.duplicate_with)
        );

        uniqueExactMatchArticlesIds = [...new Set(exactMatchingArticles)].sort(
          (a, b) => b - a
        );

        setExactMatchedArticles(uniqueExactMatchArticlesIds);

        allResults = filterDuplicates(allResults);

        const allPercentages = allResults?.flatMap((article) =>
          article?.duplicates?.map((duplicate) =>
            Math.round(duplicate.percentage * 100)
          )
        );

        const uniquePercentages = [...new Set(allPercentages)].sort(
          (a, b) => b - a
        );

        const filteredOptions = [90, 80, 70, 60, 50].filter((option) =>
          uniquePercentages.some((percentage) => percentage >= option)
        );

        setOptions(filteredOptions);

        const initialSelectedPercentage = filteredOptions.includes(80)
          ? 80
          : filteredOptions[0] || null;
        setSelectedPercentage(initialSelectedPercentage);

        const matchingArticles = allResults.flatMap((article) =>
          article.duplicates
            .filter(
              (duplicate) =>
                (duplicate.percentage * 100).toFixed(2) >=
                initialSelectedPercentage
            )
            ?.map((duplicate) => duplicate.duplicate_with)
        );

        setExcludedArticlesId(matchingArticles);
        // Update the state with the sorted results
        setGetScreeningDuplicate(allResults);
      } while (page <= totalPages);
      setTimeout(() => {
        setIsLoading(false);
        if (uniqueExactMatchArticlesIds.length > 0) {
          excludeExactMatchArticles(uniqueExactMatchArticlesIds);
        }
      }, 500);
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user.role.role !== "teamlead") {
      navigate("/screeningAbstractTotal");
    }
    fetchReviewArticles();
    localStorage.setItem("pageId", "1201");
    localStorage.setItem("subPageId", "1211");
    // setAPIResponse(localStorage.getItem("localAPIs"));
  }, []);

  // Function to truncate the text without cutting off words
  const truncateText = (text, maxLength) => {
    if (maxLength === 0) {
      return "";
    }
    if (text.length <= maxLength) {
      return text;
    }
    const truncatedText = text?.substring(0, maxLength);
    // Find the last space within the truncated text
    const lastSpaceIndex = truncatedText?.lastIndexOf(" ");
    return `${truncatedText.substring(0, lastSpaceIndex)}...`;
  };

  const calculateOriginalLength = (author, title, duplicates) => {
    const maxAuthorLength = 33;
    const baseLength = 270;
    const reductionPerStep = 25;
    const titleStep = 27;
    const authorFactor = Math.ceil(author / maxAuthorLength);
    const titleFactor = Math.floor(title / titleStep);
    const factor = Math.min(authorFactor, titleFactor);
    if (factor === 0) {
      return 60 * duplicates;
    }
    const lengthReduction = (factor - 1) * reductionPerStep;
    const originalLength = (baseLength - lengthReduction) * duplicates;
    return originalLength;
  };
  // State to track if each card content is expanded or not using an object keyed by id
  const [isExpanded, setIsExpanded] = useState({});

  // Toggle function to change the state for a specific card by id
  const toggleReadMore = (id) => {
    setIsExpanded((prevIsExpanded) => ({
      ...prevIsExpanded,
      [id]: !prevIsExpanded[id],
    }));
  };

  function capitalizeTextProperly(text) {
    // Capitalize the first letter of the text
    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Capitalize the first word after specified punctuation marks
    return text.replace(/([.?!:;]\s*)([a-z])/g, (match, punct, char) => {
      // Capitalize the character following the punctuation
      return punct + char.toUpperCase();
    });
  }

  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <div className="page--content duplicate--percentage--page">
          <div className="position-sticky position-sticky-top">
            <div className="page--section">
              <div className="row">
                <div className="col-lg-3">
                  <h1 className="page--heading">Duplicates </h1>
                </div>
                <div className="col-lg-9 text-end text-nowrap d-flex justify-content-end">
                  {getScreeningDuplicate.length > 0 && (
                    <div className="position-relative d-inline-block">
                      <select
                        id="percentageDropdown"
                        className="ms-2 screening-duplicate-percentage-dropdown"
                        value={selectedPercentage}
                        onChange={handlePercentageChange}
                        style={{ paddingRight: "2rem" }}
                        disabled={!options.length || isLoading || isExluding}
                      >
                        {options.length > 0 ? (
                          options?.map((value) => (
                            <option
                              key={value}
                              value={value}
                              className={
                                value === selectedPercentage
                                  ? "screening-duplicate-percentage-dropdown-option screening-duplicate-percentage-dropdown-selected-option"
                                  : "screening-duplicate-percentage-dropdown-option"
                              }
                            >
                              Matched {value === 100 ? "=" : ">="} {value}%
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No Matching Percentages Available
                          </option>
                        )}
                      </select>
                      {/* React icon positioned absolutely */}
                      <MdArrowDropDown
                        className="position-absolute "
                        style={{
                          top: "6%",
                          right: "1%",
                          width: "30px",
                          height: "30px",
                          pointerEvents: "none", // Prevent interaction with the icon
                          color: "black",
                        }}
                      />
                    </div>
                  )}
                  <div>
                    <button
                      className={
                        excludedArticlesId.length === 0 || isLoading
                          ? "tem--add--btn ms-2 pt-2 pb-2 border-0 include-btn-disable"
                          : "tem--add--btn ms-2 pt-2 pb-2 border-0"
                      }
                      onClick={() => excludeArticles()}
                      disabled={
                        excludedArticlesId.length === 0 ||
                        isLoading ||
                        isExluding
                      }
                    >
                      Exclude articles (
                      {[...new Set(excludedArticlesId)].length || 0})
                    </button>
                  </div>
                  <div>
                    <button
                      disabled={isLoading}
                      className={
                        isLoading
                          ? "tem--add--btn ms-2 pt-2 pb-2 border-0 shadow-none include-btn-disable"
                          : "border-0 shadow-none tem--add--btn ms-2 pt-2 pb-2"
                      }
                    >
                      <Link
                        to="/screeningAbstractTotal"
                        style={{
                          color: "#ffb703",
                        }}
                      >
                        Move to Abstract Screening
                      </Link>
                    </button>
                  </div>
                </div>
              </div>
              {/* {isLoading && progress < 100 && ( */}

              {/* // )} */}
            </div>
            {isLoading && (
              <div className="progressBarData">
                <ProgressBar now={progress} />
              </div>
            )}
          </div>
          {getScreeningDuplicate &&
            getScreeningDuplicate?.length > 0 &&
            getScreeningDuplicate
              .sort((a, b) => {
                // Find the maximum percentage in duplicates for both articles a and b
                const maxPercentageA = Math.max(
                  ...a?.duplicates?.map((dup) => dup.percentage * 100)
                );
                const maxPercentageB = Math.max(
                  ...b?.duplicates?.map((dup) => dup.percentage * 100)
                );

                // Sort by the maximum percentage, descending
                return maxPercentageB - maxPercentageA;
              })
              ?.map(
                (
                  {
                    id,
                    abstract,
                    journal,
                    authors,
                    duplicates,
                    title,
                    pub_date,
                  },
                  index
                ) => {
                  return (
                    <div className="duplicate--div">
                      <div className="two-column-layout">
                        <div
                          className={duplicates.length > 1 ? "left-1" : "left"}
                        >
                          <div
                            className={
                              studyActive === id && isChecked === true
                                ? "inner--box--row--active"
                                : "inner--box--row"
                            }
                          >
                            <div className="w-100">
                              <div className="progressBar"></div>
                              <div className="d-flex ">
                                <p className="text-muted authors-font ms-1 mb-1">
                                  <span className="authors-font fw-bold">
                                    Author(s):
                                  </span>{" "}
                                  {capitalizeWords(
                                    authors.replace(/,/g, ", ")
                                  ) + "."}
                                </p>
                              </div>
                              <h1 className="screening-duplicate-article-title">
                                {parse(
                                  formatOvidTags(
                                    convertFirstLetterToUpperCase(title)
                                  )
                                )}
                              </h1>
                              {journal ? (
                                <p className="small text-muted journal-font">
                                  {" "}
                                  <span className="fw-bold">Journal:</span>{" "}
                                  {capitalizeWords(journal) + "."}
                                </p>
                              ) : (
                                ""
                              )}

                              {duplicates?.length === 1 ? (
                                <p className="inline-block">
                                  {isExpanded[id]
                                    ? parse(
                                        formatOvidTags(
                                          capitalizeTextProperly(abstract)
                                        )
                                      )
                                    : // ? abstract
                                      parse(
                                        formatOvidTags(
                                          truncateText(
                                            capitalizeTextProperly(abstract),
                                            // abstract,
                                            112
                                          )
                                        )
                                      )}
                                </p>
                              ) : (
                                <p className="inline-block">
                                  {isExpanded[id]
                                    ? parse(
                                        formatOvidTags(
                                          capitalizeTextProperly(abstract)
                                        )
                                      )
                                    : // ? abstract
                                      parse(
                                        formatOvidTags(
                                          truncateText(
                                            capitalizeTextProperly(abstract),
                                            // abstract,
                                            calculateOriginalLength(
                                              authors?.length,
                                              title?.length,
                                              duplicates?.length
                                            )
                                          )
                                        )
                                      )}
                                </p>
                              )}
                              {duplicates?.length === 1
                                ? abstract?.length > 112 && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReadMore(id);
                                      }}
                                      className="read--more-read-less-btn"
                                    >
                                      {isExpanded[id]
                                        ? "Read less"
                                        : "Read more"}
                                    </button>
                                  )
                                : abstract.length >
                                    calculateOriginalLength(
                                      authors?.length,
                                      title?.length,
                                      duplicates?.length
                                    ) && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleReadMore(id);
                                      }}
                                      className="read--more-read-less-btn"
                                    >
                                      {isExpanded[id]
                                        ? "Read less"
                                        : "Read more"}
                                    </button>
                                  )}
                              <p>{pub_date}</p>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            duplicates.length > 1 ? "right-2" : "right"
                          }
                        >
                          {duplicates && duplicates.length > 0
                            ? duplicates?.map((duplicate, key) => {
                                return (
                                  <>
                                    <div className="col">
                                      <div
                                        className={
                                          duplicateActive !==
                                            duplicate.duplicate_with ||
                                          duplicateActive !== duplicate.id
                                            ? "inner--box--row"
                                            : "inner--box--row--active"
                                        }
                                        id={duplicate.duplicate_with}
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor:
                                            excludedArticlesId.includes(
                                              duplicate.duplicate_with
                                            ) === true
                                              ? "rgba(255,0,0,0.2)"
                                              : "rgba(0,0,0,0)",
                                        }}
                                        onClick={() =>
                                          handleDuplicateActive(
                                            duplicate.duplicate_with,
                                            duplicate.id
                                          )
                                        }
                                      >
                                        <div className="w-100">
                                          {/* <h4>{duplicate.duplicate_with}</h4> */}
                                          <div className="progressBar">
                                            <ProgressBar
                                              now={duplicate.percentage * 100}
                                              label={`${(
                                                duplicate.percentage * 100
                                              ).toFixed(2)} %`}
                                            />
                                          </div>

                                          {duplicates?.length === 1 ? (
                                            <div className="d-flex ">
                                              <p className="text-muted authors-font ms-1 mb-1">
                                                <span className="authors-font fw-bold">
                                                  Author(s):
                                                </span>{" "}
                                                {capitalizeWords(
                                                  duplicate.article.authors.replace(
                                                    /,/g,
                                                    ", "
                                                  )
                                                ) + "."}
                                              </p>
                                            </div>
                                          ) : (
                                            <div className="d-flex ">
                                              <p className="text-muted authors-font ms-1 mb-1">
                                                <span className="authors-font fw-bold">
                                                  Author(s):
                                                </span>{" "}
                                                {isExpanded[duplicate.id]
                                                  ? capitalizeWords(
                                                      duplicate.article.authors
                                                    ) + "."
                                                  : truncateText(
                                                      capitalizeWords(
                                                        duplicate.article
                                                          .authors
                                                      ) + ".",
                                                      60
                                                    )}
                                              </p>
                                            </div>
                                          )}

                                          {duplicates?.length === 1 ? (
                                            <h1 className="screening-duplicate-article-title">
                                              {parse(
                                                formatOvidTags(
                                                  convertFirstLetterToUpperCase(
                                                    duplicate.article.title
                                                  )
                                                )
                                              )}
                                            </h1>
                                          ) : (
                                            <h1 className="screening-duplicate-article-title">
                                              {isExpanded[duplicate.id]
                                                ? parse(
                                                    formatOvidTags(
                                                      convertFirstLetterToUpperCase(
                                                        duplicate.article?.title
                                                      )
                                                    )
                                                  )
                                                : parse(
                                                    formatOvidTags(
                                                      truncateText(
                                                        convertFirstLetterToUpperCase(
                                                          duplicate.article
                                                            ?.title
                                                        ),
                                                        50
                                                      )
                                                    )
                                                  )}
                                            </h1>
                                          )}
                                          {duplicate.article.journal ? (
                                            <p className="small text-muted journal-font">
                                              {" "}
                                              <span className="fw-bold">
                                                {isExpanded[duplicate.id] &&
                                                  "Journal:"}
                                              </span>{" "}
                                              {isExpanded[duplicate.id]
                                                ? capitalizeWords(
                                                    duplicate.article.journal
                                                  ) + "."
                                                : truncateText(
                                                    capitalizeWords(
                                                      duplicate.article.journal
                                                    ) + ".",
                                                    0
                                                  )}
                                            </p>
                                          ) : (
                                            ""
                                          )}

                                          {duplicates?.length === 1 ? (
                                            <p className="inline-block">
                                              {isExpanded[duplicate.id]
                                                ? parse(
                                                    formatOvidTags(
                                                      capitalizeTextProperly(
                                                        duplicate.article
                                                          .abstract
                                                      )
                                                    )
                                                  )
                                                : parse(
                                                    formatOvidTags(
                                                      truncateText(
                                                        capitalizeTextProperly(
                                                          duplicate.article
                                                            .abstract
                                                        ),
                                                        112
                                                      )
                                                    )
                                                  )}
                                            </p>
                                          ) : (
                                            <p className="inline-block">
                                              {isExpanded[duplicate.id]
                                                ? parse(
                                                    formatOvidTags(
                                                      capitalizeTextProperly(
                                                        duplicate.article
                                                          .abstract
                                                      )
                                                    )
                                                  )
                                                : parse(
                                                    formatOvidTags(
                                                      truncateText(
                                                        capitalizeTextProperly(
                                                          duplicate.article
                                                            .abstract
                                                        ),
                                                        // 150
                                                        0
                                                      )
                                                    )
                                                  )}
                                            </p>
                                          )}

                                          {duplicates?.length === 1
                                            ? duplicate.article.abstract
                                                .length > 112 && (
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleReadMore(
                                                      duplicate.id
                                                    );
                                                  }}
                                                  className="read--more-read-less-btn"
                                                >
                                                  {isExpanded[duplicate.id]
                                                    ? "Read less"
                                                    : "Read more"}
                                                </button>
                                              )
                                            : (duplicate.article.abstract
                                                ?.length > 150 ||
                                                duplicate.article.title
                                                  ?.length > 100 ||
                                                duplicate.article.authors
                                                  ?.length > 60) && (
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleReadMore(
                                                      duplicate.id
                                                    );
                                                  }}
                                                  className="read--more-read-less-btn"
                                                >
                                                  {isExpanded[duplicate.id]
                                                    ? "Read less"
                                                    : "Read more"}
                                                </button>
                                              )}

                                          <p>{duplicate.article.pub_date}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
          {!isLoading && getScreeningDuplicate?.length === 0 && !isError && (
            // <p className="p-3 text-muted">There are no duplicate articles.</p>
            <div className="no-data-found-main">
              <h4 className="no-data-found text-muted m-auto opacity-50">
                <FaExclamationTriangle size={50} color="orange" />
                <span className="ms-3">There are no duplicate articles.</span>
              </h4>
            </div>
          )}
          {isError && !isLoading && (
            <div className="no-data-found-main">
              <h4 className="no-data-found text-muted m-auto opacity-50">
                <BiErrorCircle size={50} color="orange" />
                <span className="ms-3">Some thing went wrong..</span>
              </h4>
            </div>
          )}
          {isLoading && (
            <div
              className={
                getScreeningDuplicate?.length >= 25
                  ? "loading-second-time"
                  : "preload"
              }
            >
              <img src={gif} alt="Loading..." />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ScreeningDuplicate;
